// libs
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// app
import { LoadingComponent } from './_pages/loading/loading.component';


export const routes: Routes = [
  {
    path: '',
    component: LoadingComponent,
  },
  {
    path: 'no-access',
    loadChildren: () => import('src/app/_pages/access-denied/access-denied.module').then(m => m.AccessDeniedModule),
  },
  {
    path: 'additional-info',
    loadChildren: () => import('src/app/_pages/additional-info/additional-info.module').then(m => m.AdditionalInfoModule),
  },
  {
    path: 'chat',
    loadChildren: () => import('src/app/_pages/chat/chat.module').then(m => m.ChatModule),
  },
  {
    path: 'transfer',
    loadChildren: () => import('src/app/_pages/transfer/transfer.module').then(m => m.TransferModule),
  },
  {
    path: 'doc-check',
    loadChildren: () => import('src/app/_pages/doc-check/doc-check.module').then(m => m.DocCheckModule),
  },
  {
    path: 'error',
    loadChildren: () => import('src/app/_pages/error/error.module').then(m => m.ErrorModule),
  },
  {
    path: 'flight-selection',
    loadChildren: () => import('src/app/_pages/flight-selection/flight-selection.module').then(m => m.FlightSelectionModule),
  },
  {
    path: 'help-options',
    loadChildren: () => import('src/app/_pages/help-options/help-options.module').then(m => m.HelpOptionsModule),
  },
  {
    path: 'no-agents',
    loadChildren: () => import('src/app/_pages/no-agents/no-agents.module').then(m => m.NoAgentsModule),
  },
  {
    path: 'session-error',
    loadChildren: () => import('src/app/_pages/session-error/session-error.module').then(m => m.SessionErrorModule),
  },
  {
    path: 'unavailable',
    loadChildren: () => import('src/app/_pages/aod-rez-line/aod-rez-line.module').then(m => m.AodRezModule),
  },
  {
    path: 'contact',
    loadChildren: () => import('src/app/_pages/contact/contact.module').then(m => m.ContactModule),
  },
  {
    path: 'pre-chat',
    loadChildren: () => import('src/app/_pages/prechat/prechat.module').then(m => m.PrechatModule),
  },
  {
    path: 'self-service',
    loadChildren: () => import('src/app/_pages/self-service-options/self-service-options.module').then(m => m.SelfServiceOptionsModule),
  },
  {
    path: 'waiting-room',
    loadChildren: () => import('src/app/_pages/waiting-room/waiting-room.module').then(m => m.WaitingRoomModule),
  },
  {
    path: 'welcome',
    loadChildren: () => import('src/app/_pages/welcome/welcome.module').then(m => m.WelcomeModule),
  },
  {
    path: 'select-traveler',
    loadChildren: () => import('src/app/_pages/traveler-selection/traveler-selection.module').then(m => m.TravelerSelectionModule),
  },
  {
    path: 'invalid-browser',
    loadChildren: () => import('src/app/_pages/invalid-browser/invalid-browser.module').then(m => m.InvalidBrowserModule),
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
